import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flw-overlay"
}
const _hoisted_2 = {
  class: "flw-box",
  role: "alertdialog",
  "aria-live": "assertive",
  "aria-label": "Sessão encerrada"
}
const _hoisted_3 = {
  key: 0,
  class: "flw-countdown"
}
const _hoisted_4 = { class: "flw-title" }
const _hoisted_5 = {
  key: 1,
  class: "flw-desc"
}
const _hoisted_6 = {
  key: 2,
  class: "flw-desc"
}
const _hoisted_7 = {
  key: 3,
  class: "flw-desc"
}
const _hoisted_8 = {
  class: "flw-label",
  for: "flw-password"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "flw-error"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "flw-actions" }
const _hoisted_13 = ["disabled"]

import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import {
  showForceLogout, forceLogoutSecondsLeft, forceLogoutKind, forceLogoutBy, logoutNowForced, resetForceLogout, pauseForceLogoutCountdown,
} from '@/composables/useForceLogout'
import { adoptNewToken } from '@/composables/useSessionTracking'
import { signInWootDash } from '@/services/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'ForceLogoutWarningModal',
  setup(__props) {

// Aviso de sessão encerrada. "Continuar logado" faz um login novo com a senha e troca o token em todo o painel
// (adoptNewToken) — a tela, os rascunhos e o que estava aberto continuam. Pra conta desativada não tem como continuar.
const TITLE: Record<'account' | 'session' | 'expired', string> = {
  session: 'Esta sessão foi revogada pelo Sistema',
  expired: 'Sua sessão expirou',
  account: 'Você foi deslogado pelo Sistema',
}

const store  = useStore()
const router = useRouter()

const password = ref('')
const busy = ref(false)
const error = ref('')
const paused = ref(false)
const email = computed<string>(() => store.getters.authUser?.email ?? '')
const canContinue = computed(() => forceLogoutKind.value !== 'account' && !!email.value)

watch(showForceLogout, open => {
  if (!open) return
  password.value = ''
  error.value = ''
  paused.value = false
  // Expirou: não tem o que salvar com pressa — espera a senha.
  if (forceLogoutKind.value === 'expired') pause()
})

function pause() {
  if (paused.value) return
  paused.value = true
  pauseForceLogoutCountdown()
}

async function continueLogged() {
  if (!password.value || busy.value) return
  busy.value = true
  error.value = ''
  try {
    const session = await signInWootDash(email.value, password.value)
    adoptNewToken(store, session.token)
    password.value = ''
    resetForceLogout()
  } catch (e: any) {
    error.value = e?.message === 'Credenciais inválidas' ? 'Senha incorreta. Tente de novo.' : (e?.message || 'Não deu pra entrar. Tente de novo.')
  } finally {
    busy.value = false
  }
}

function handleLogout() {
  logoutNowForced(store, router)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "flw-fade" }, {
      default: _withCtx(() => [
        (_unref(showForceLogout))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (!paused.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(forceLogoutSecondsLeft)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, _toDisplayString(TITLE[_unref(forceLogoutKind)]), 1),
                (_unref(forceLogoutBy))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[1] || (_cache[1] = _createTextVNode("Revogada por ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_unref(forceLogoutBy)), 1),
                      _cache[2] || (_cache[2] = _createTextVNode(".", -1))
                    ]))
                  : _createCommentVNode("", true),
                (_unref(forceLogoutKind) === 'expired')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " O acesso venceu enquanto a aba ficou parada. Digite a senha pra continuar de onde parou. "))
                  : (!paused.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[3] || (_cache[3] = _createTextVNode(" Salve o que estiver fazendo: você será desconectado em ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_unref(forceLogoutSecondsLeft)) + "s", 1),
                        _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
                      ]))
                    : _createCommentVNode("", true),
                (canContinue.value)
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 4,
                      class: "flw-continue",
                      onSubmit: _withModifiers(continueLogged, ["prevent"])
                    }, [
                      _createElementVNode("label", _hoisted_8, [
                        _cache[5] || (_cache[5] = _createTextVNode("Senha de ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(email.value), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        id: "flw-password",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                        class: "flw-input",
                        type: "password",
                        autocomplete: "current-password",
                        placeholder: "Sua senha",
                        disabled: busy.value,
                        onFocus: pause,
                        onInput: pause
                      }, null, 40, _hoisted_9), [
                        [_vModelText, password.value]
                      ]),
                      (error.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(error.value), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "flw-btn flw-btn--primary",
                        disabled: busy.value || !password.value
                      }, _toDisplayString(busy.value ? 'Entrando…' : 'Continuar logado'), 9, _hoisted_11)
                    ], 32))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["flw-btn", canContinue.value ? 'flw-btn--ghost' : 'flw-btn--primary']),
                    disabled: busy.value,
                    onClick: handleLogout
                  }, " Sair agora ", 10, _hoisted_13)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})